import { createSelector } from 'reselect';
import { Booking, Reservation } from '../api/types';
import Logger from '../common/logger';
import { ReduxState } from '../reducer/reducer';
import { RootState } from '../store/store';

const stateKey = 'bookings';

export const bookingListSelector = (state: RootState): Record<string, Booking> => state.legacy[stateKey].booking;
export const bookingsListSelector = (state: RootState): Booking[] => state.legacy[stateKey].bookings;
export const guestBookingSelector = (state: RootState): Booking | null => state.legacy[stateKey].guestBooking;
export const reservationSelector = (state: RootState): Reservation | null => state.legacy[stateKey].reservation;

export const makeBookingSelector = (bookingId: string) => {
    return createSelector([bookingListSelector], (bookingList): Booking|null => {
        return bookingList[bookingId] || null;
    });
};

export const makeBookingSelectorByBookingId = (bookingId: string) => {
    return createSelector([bookingListSelector], (bookingList): Booking|null => {
        const bookings = Object.values(bookingList);
        return bookings.find(booking => booking.id === bookingId) || null;
    });
};

export const makeBookingMultipleSelector = (
    bookingIds: string[],
    idType: string = 'bookingNumber',
    tenant: string | null,
) => {
    return createSelector([bookingsListSelector], (bookingList: Booking[]): (Booking | undefined)[] | null => {
        Logger('booking List').log(bookingList);
        Logger('bookingIds').log(bookingIds);

        if (tenant !== 'vonovia' && tenant !== 'segmenta') {
            // Filter bookings
            return bookingIds.map(
                (bookingId: string) => Object.values(bookingList).find(
                    (booking: Booking) => booking[idType as keyof Booking] === bookingId),
            );
        }
        return null;
    });
};

export const makeGuestBookingSelector = () => {
    return createSelector([guestBookingSelector], (guestBooking): Booking|null => {
        return guestBooking || null;
    });
};


export const visitorBookingListSelector = (state: ReduxState): Booking[] => 
    state[stateKey].visitorBookings; 


export const makeVisitorBookingSelector = () => {
    return createSelector(
        [visitorBookingListSelector],
        (visitorBookingsList): Booking[] => {
            return visitorBookingsList;
        },
    );
};
